<template>
  <v-container class="container-page">
    <recipient-list />
    <router-view />
  </v-container>
</template>

<script>
  import RecipientList from './List'
  export default {
    components: { RecipientList }
  }
</script>
